import { compose, pick, assoc } from 'ramda'

export const cleanRequest = (item, clone) =>
  compose(
    pick(['id', 'sourceProjectId', 'name', 'color', 'icon']), //
    assoc('sourceProjectId', clone ? item.id : undefined),
    assoc('id', !clone ? item.id : undefined)
  )(item)
